export const UserType = {
  SLAUser: "SLA",
  SLIPUser: "SLIP"
};
